export default "__VITE_PUBLIC_ASSET__eaf723f6__"